<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :md="6" :sm="8">
            <a-form-item :label="language['user.column.userName']">
              <!--<a-input placeholder="请输入账号查询" v-model="queryParam.username"></a-input>-->
              <a-input :placeholder="language['common.pleaseInput']+language['user.column.userName']" v-model="queryParam.username" allowClear></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="language['user.column.workNo']">
              <!--<a-input placeholder="请输入账号查询" v-model="queryParam.username"></a-input>-->
              <a-input :placeholder="language['common.pleaseInput']+language['user.column.workNo']" v-model="queryParam.workNo" allowClear></a-input>
            </a-form-item>
          </a-col>


          <a-col :md="6" :sm="8">
            <a-form-item :label="language['column.realName']">
              <a-input :placeholder="language['common.pleaseInput']+language['column.realName']" v-model="queryParam.realname" allowClear></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item :label="language['user.column.phone']">
              <a-input :placeholder="language['common.pleaseInput']+language['user.column.phone']" v-model="queryParam.phone" allowClear></a-input>
            </a-form-item>
          </a-col>

          <template v-if="toggleSearchStatus">
            <a-col :md="6" :sm="8">
              <a-form-item :label="language['user.column.userType']">
                <a-select v-model="queryParam.userType" :placeholder="language['common.pleaseChoose']+language['user.column.userType']" allowClear>
                  <a-select-option value="employee">{{language['employee']}}</a-select-option>
                  <a-select-option value="nonemployee">{{language['nonemployee']}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="8">
              <a-form-item :label="language['user.column.sex']">
                <a-select v-model="queryParam.sex" :placeholder="language['common.pleaseChoose']+language['user.column.sex']" allowClear>
                  <a-select-option value="1">{{language['common.sex.man']}}</a-select-option>
                  <a-select-option value="2">{{language['common.sex.woman']}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="8">
              <a-form-item :label="language['user']+language['user.column.status']">
                <a-select v-model="queryParam.status" :placeholder="language['common.pleaseChoose']" allowClear>
                  <a-select-option value="1">{{language['downBoxValue.normal']}}</a-select-option>
                  <a-select-option value="2">{{language['downBoxValue.freeze']}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :xl="10" :lg="11" :md="12" :sm="24" v-if="application.applicationType === 'platform'">
              <a-form-item :label="language['application']">
                <a-select v-model="queryParam.selectedApplicationId" allowClear  :placeholder="language['common.pleaseChoose']+language['application']" style="width: 35%;padding-right: 10px">
                  <a-select-option v-for="(item,index) in applicationOptions" :key="index" :value="item.id" allowClear>
                    {{ item.applicationNameLanguage||item.applicationName }}
                  </a-select-option>
                </a-select>
                <a-radio-group v-model="queryParam.applicationBy" @change="change">
                  <a-radio value="user">{{language['user']}}</a-radio>
                  <a-radio value="role">{{language['role']}}</a-radio>
                </a-radio-group>
              </a-form-item>
            </a-col>

          </template>

          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                  {{ toggleSearchStatus ? language['common.foldButton'] : language['common.unfoldButton'] }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator" style="border-top: 5px">
      <a-button  type="primary" icon="download" @click="uploadDepartXls" v-has="'user:uploadDepartXls'">{{language['common.importButton']}}</a-button><!--'departlist:import'-->
      <a-button @click="handleAdd" type="primary" icon="plus" v-has="'user:add'">{{language['common.insertButton']}}</a-button>
      <a-button @click="handleSetPasswordBatch" type="primary" icon="edit" v-has="'user:batchPassword'">{{language['portal.ui2.setPasswordT']}}</a-button>
      <!--<a-button type="primary" icon="download" @click="handleExportXls('用户信息')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <j-third-app-button biz-type="user" :selected-row-keys="selectedRowKeys" syncToApp syncToLocal @sync-finally="onSyncFinally"/>-->
      <a-button type="primary" icon="hdd" v-has="'user:recycle'" @click="recycleBinVisible=true">{{language['common.recycleBin']}}</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay" @click="handleMenuClick">
          <a-menu-item key="1" v-has="'user:batchDelete'">
            <a-icon type="delete" @click="batchDel"/>
            {{language['common.delete']}}
          </a-menu-item>
          <a-menu-item key="2" v-has="'user:batchlock'">
            <a-icon type="lock" @click="batchFrozen('2')"/>
            {{language['downBoxValue.freeze']}}
          </a-menu-item>
          <a-menu-item key="3" v-has="'user:batchunlock'">
            <a-icon type="unlock" @click="batchFrozen('1')"/>
            {{language['common.thawButton']}}
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          {{language['common.batchAction']}}
          <a-icon type="down"/>
        </a-button>
      </a-dropdown>
<!--      <j-super-query :fieldList="superQueryFieldList" @handleSuperQuery="handleSuperQuery"/>-->
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>{{language['common.choosed']}}&nbsp;<a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{language['common.item']}}&nbsp;&nbsp;
        <a style="margin-left: 24px" @click="onClearSelected">{{language['common.clear']}}</a>
      </div>

      <a-table
        ref="table"
        bordered
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange"
        :scroll="{x:true}"><!-- :scroll="{x:true}" -->

        <template slot="avatarslot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <a-avatar shape="square" :src="getAvatarView(record.avatar)" icon="user"/>
          </div>
        </template>
        <template slot="email" slot-scope="text, record, index">
          <a-tooltip :title="record.email" placement="topLeft" :disabled="false">
            <span>{{record.email}}</span>
          </a-tooltip>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)" v-has="'user:edit'">{{language['common.edit']}}</a>
          <a-divider type="vertical" v-has="'user:edit'"/>
          <a @click="bindApplication(record)" v-if="$store.getters.application.applicationType === 'platform'" v-has="'user:bindApplication'">{{language['user.bindApplicationBtn']}}</a>
          <a-divider type="vertical" v-if="$store.getters.application.applicationType === 'platform'" v-has="'user:bindApplication'"/>

          <a-dropdown>
            <a class="ant-dropdown-link">
              {{language['common.more']}} <a-icon type="down"/>
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a href="javascript:;" @click="handleDetail(record)">{{language['common.detailsButton']}}</a>
              </a-menu-item>

              <a-menu-item>
                <a href="javascript:;" @click="handleChangePassword(record.username)" v-has="'user:password'">{{language['column.password']}}</a>
              </a-menu-item>

              <a-menu-item v-has="'user:delete'">
                  <a-popconfirm :title="language['common.deleteConfirmInfo']" :okText="language['common.okButton']" :cancelText="language['common.cancel']" @confirm="() => handleDelete(record.id)">
                  <a>{{language['common.delete']}}</a>
                </a-popconfirm>
              </a-menu-item>

              <a-menu-item v-if="record.status==1" v-has="'user:lock'">
                <a-popconfirm :title="language['tip.messageSureToFreeze']" :okText="language['common.okButton']" :cancelText="language['common.cancel']" @confirm="() => handleFrozen(record.id,2,record.username)">
                  <a>{{language['downBoxValue.freeze']}}</a>
                </a-popconfirm>
              </a-menu-item>

              <a-menu-item v-if="record.status==2" v-has="'user:unlock'">
                <a-popconfirm :title="language['tip.messageSureToThaw']" :okText="language['common.okButton']" :cancelText="language['common.cancel']" @confirm="() => handleFrozen(record.id,1,record.username)">
                  <a>{{language['common.thawButton']}}</a>
                </a-popconfirm>
              </a-menu-item>

              <a-menu-item v-has="'user:agent'">
                <a href="javascript:;" @click="handleAgentSettings(record.username)">{{language['common.agentButton']}}</a>
              </a-menu-item>

            </a-menu>
          </a-dropdown>
        </span>


      </a-table>
    </div>
    <!-- table区域-end -->

    <user-modal ref="modalForm" @ok="modalFormOk"></user-modal>

    <password-modal ref="passwordmodal" @ok="passwordModalOk"></password-modal>
    <password-batch-modal ref="passwordbatchmodal" ></password-batch-modal>

    <sys-user-agent-modal ref="sysUserAgentModal"></sys-user-agent-modal>

    <!-- 用户回收站 -->
    <user-recycle-bin-modal :visible.sync="recycleBinVisible" @ok="modalFormOk"/>

    <user-application-model ref="UserApplicationModel" @ok="modalFormOk"/>

    <user-upload-or-download-modal ref="UserUploadOrDownloadModal" @ok="loadData(1)"/>
  </a-card>
</template>

<script>
  import UserModal from './modules/UserModal'
  import PasswordModal from './modules/PasswordModal'
  import {getAction,postAction,putAction,getFileAccessHttpUrl} from '@/api/manage';
  import {frozenBatch,applicationList} from '@/api/api'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import SysUserAgentModal from "./modules/SysUserAgentModal";
  import JInput from '@/components/jeecg/JInput'
  import UserRecycleBinModal from './modules/UserRecycleBinModal'
  import JSuperQuery from '@/components/jeecg/JSuperQuery'
  import JThirdAppButton from '@/components/jeecgbiz/thirdApp/JThirdAppButton'
  import UserApplicationModel from './modules/UserApplicationModel'
  import UserUploadOrDownloadModal from "./modules/UserUploadOrDownloadModal"
  import { getDictItemsFromCache } from '@/api/api'
  import { filterDictText } from '@/components/dict/JDictSelectUtil'
  import PasswordBatchModal from './modules/PasswordBatchModal'

  export default {
    name: "UserList",
    mixins: [JeecgListMixin],
    components: {
      JThirdAppButton,
      SysUserAgentModal,
      UserModal,
      PasswordModal,
      JInput,
      UserRecycleBinModal,
      JSuperQuery,
      UserApplicationModel,
      UserUploadOrDownloadModal,
      PasswordBatchModal
    },
    data() {
      return {
        description: '这是用户管理页面',
        queryParam: {applicationBy:'user'},
        recycleBinVisible: false,
        applicationOptions:[],
        selectedApplicationId:'',
        uploadSource:"platform",

        /*superQueryFieldList: [
          { type: 'input', value: 'username', text: '用户账号', },
          { type: 'input', value: 'realname', text: '用户姓名', },
          { type: 'select', value: 'sex', dbType: 'int', text: '性别', dictCode: 'sex' },
        ],*/
        url: {
          syncUser: "/act/process/extActProcess/doSyncUser",
          list: "/sys/user/list",
          // list: this.$store.getters.application.applicationType=='platform'?"/sys/user/list":"/sys/role/list?applicationId="+this.$store.getters.application.id,
          delete: "/sys/user/delete",
          deleteBatch: "/sys/user/deleteBatch",
          exportXlsUrl: "/sys/user/exportXls",
          importExcelUrl: "sys/user/importExcel",
        },
        application:{},
        disableMixinCreated: true,
        sexList: [],
        statusList: [],
        userTypeList: [],
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      language() {
        return this.$store.getters.language
      },
      columns(){
        if(this.language){
          return [
            {
              title: this.language['user.column.userName'],
              align: "center",
              dataIndex: 'username',
              width: 160,
              //sorter: true
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title: this.language['user.column.createTime'],
              align: "center",
              dataIndex: 'createTime',
              width: 150,
              //sorter: true
            },
            {
              title: this.language['user.column.userType'],
              align: "center",
              //dataIndex: 'userType_dictText',
              dataIndex: 'userType',
              width: 100,
              customRender: (text) => {
                return filterDictText(this.userTypeList, text)
              },
            },
            {
              title: this.language['user.column.workNo'],
              align: "center",
              dataIndex: 'workNo',
              width: 140,
              customRender: function(t, r, index) {
                if(r.userType == 'employee'){
                  return t;
                }else{
                  return "";
                }
              },
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title: this.language['user.column.realname'],
              align: "center",
              width: 120,
              dataIndex: 'realname',
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title: this.language['user.column.sex'],
              align: "center",
              width: 80,
              //dataIndex: 'sex_dictText',
              dataIndex: 'sex',
              //sorter: true,
              customRender: (text) => {
                return filterDictText(this.sexList, text)
              },
            },
            {
              title: this.language['user.column.phone'],
              align: "center",
              width: 150,
              dataIndex: 'phone'
            },
            {
              title: this.language['column.mailbox'],
              align: "center",
              width: 250,
              ellipsis: true,
              dataIndex: 'email',
              scopedSlots: {customRender: "email"},
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title: this.language['user.column.Avatar'],
              align: "center",
              width: 100,
              dataIndex: 'avatar',
              scopedSlots: {customRender: "avatarslot"}
            },

            
            
            
            /* {
              title: this.language['user.column.birthday'],
              align: "center",
              width: 120,
              dataIndex: 'birthday'
            }, */
            
            
            /*{
              title: '部门',
              align: "center",
              width: 350,
              dataIndex: 'orgCodeTxt'
            },*/
            /* {
              title: this.language['user.column.responsibleDepart'],
              align: "center",
              width: 300,
              dataIndex: 'responsibleDepartName'
            }, */
            {
              title: this.language['user.column.status'],
              align: "center",
              width: 100,
              //dataIndex: 'status_dictText',
              dataIndex: 'status',
              customRender: (text) => {
                return filterDictText(this.statusList, text)
              },
            },
            {
              title: this.language['common.action'],
              dataIndex: 'action',
              scopedSlots: {customRender: 'action'},
              align: "center",
              width: 170,
              fixed:"right"
            }

          ]
        }
      }
    },
    created() {
      // this.getThisapplication();
      this.application = this.$store.getters.application
      this.initDictConfig();
      this.statusList = getDictItemsFromCache('user_status');
      this.userTypeList = getDictItemsFromCache('user_type_emp');
      this.sexList = getDictItemsFromCache('sex');

      if(this.$store.getters.application.applicationType === 'platform') {
        this.initApplicationList();
        this.loadData();
      }else{
        this.queryParam = {selectedApplicationId:this.application.id,applicationBy:'user'}
        console.log("------------------"+this.queryParam)
        this.loadData(1);
      }
    },
    methods: {
      uploadDepartXls(){
        this.$refs.UserUploadOrDownloadModal.edit(this.application)
      },
      searchReset() {
        if(this.$store.getters.application.applicationType === 'platform'){
          this.queryParam ={
            applicationBy:'user'
          }
        }else{
          this.queryParam = {selectedApplicationId:this.application.id,applicationBy:'user'}
        }
        this.loadData(1);
      },
      change(e){
        this.queryParam.applicationBy = e.target.value
      },
      handleEdit(record){
        let params = {
          id: record.id,
        };
        getAction("/sys/user/getUserApplications", params).then((res)=> {
          if (res.success) {
            let apps = [];
            let list = res.result;
            if(list){
              list.forEach(item=>{
                apps.push(item.id)
              })
            }
            this.$refs.modalForm.title = this.language['common.edit'];
            record.setEdit = true;
            this.$refs.modalForm.edit(record,apps);
          }
        })

      },
      getAvatarView: function (avatar) {
        return getFileAccessHttpUrl(avatar,this.uploadSource)
      },

      batchFrozen: function (status) {
        if (this.selectedRowKeys.length <= 0) {
          this.$message.warning(this.language['tip.messageSelectRecord']);
          return false;
        } else {
          let ids = "";
          let that = this;
          let isAdmin = false;
          that.selectionRows.forEach(function (row) {
            if (row.username == 'admin') {
              isAdmin = true;
            }
          });
          if (isAdmin) {
            that.$message.warning(this.language['PlatForm.employee.adminNotAllow']);
            return;
          }
          that.selectedRowKeys.forEach(function (val) {
            ids += val + ",";
          });
          that.$confirm({
            title: this.language['confirm.titleConfirmOperation'],
            content: this.language["common.whether"] + (status == 1 ? this.language["common.thawButton"] : this.language["downBoxValue.freeze"]) + this.language["content.message.selectedAccount"],
            onOk: function () {
              frozenBatch({ids: ids, status: status}).then((res) => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.loadData();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              });
            }
          });
        }
      },
      handleMenuClick(e) {
        if (e.key == 1) {
          this.batchDel();
        } else if (e.key == 2) {
          this.batchFrozen(2);
        } else if (e.key == 3) {
          this.batchFrozen(1);
        }
      },
      handleFrozen: function (id, status, username) {
        let that = this;
        //TODO 后台校验管理员角色
        if ('admin' == username) {
          that.$message.warning(this.language['PlatForm.employee.adminNotAllow']);
          return;
        }
        frozenBatch({ids: id, status: status}).then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            that.loadData();
          } else {
            that.$message.warning(res.message);
          }
        });
      },
      handleChangePassword(username) {
        this.$refs.passwordmodal.show(username);
      },
      handleSetPasswordBatch() {
        this.$refs.passwordbatchmodal.show();
      },
      handleAgentSettings(username){
        this.$refs.sysUserAgentModal.agentSettings(username);
        this.$refs.sysUserAgentModal.title = this.language["PlatForm.employee.UserAgent"];
      },
      passwordModalOk() {
        //TODO 密码修改完成 不需要刷新页面，可以把datasource中的数据更新一下
      },
      onSyncFinally({isToLocal}) {
        // 同步到本地时刷新下数据
        if (isToLocal) {
          this.loadData()
        }
      },
      /*getThisapplication(){
        let param = {}
        param.code = this.$store.getters.applicationCode
        getAction("/sys/sysBmApplication/queryByCode", param).then((res) => {
          if (res.success) {
            this.application = res.result;
            if(res.result.applicationType === 'platform'){
              this.initApplicationList();
            }else{
              this.queryParam = {selectedApplicationId:this.application.id,applicationBy:'user'}
              this.loadData(1);
            }
          }
        })
      },*/
      initApplicationList(){
        let that = this;
        applicationList().then((res) => {
          if(res.success){
            that.applicationOptions = res.result;
            console.log('this.applicationOptions: ',this.applicationOptions)
          }
        })
      },
      bindApplication(record){
        this.$refs.UserApplicationModel.edit(record);
      },
    }

  }
</script>
<style scoped>
  @import '~@assets/less/common.less'
</style>